export default "__VITE_ASSET__BbcB3eb1__"